const GTM_CONTAINER_ID = 'GTM-WZSNRJX';
const USERCENTRICS_RELEVANT_EVENTS = new Set(['DENY_ALL', 'SAVE', 'ACCEPT_ALL', 'UC_UI_INITIALIZED']);

type UsercentricsService = {
  name?: string;
  consent?: {
    status?: boolean;
  };
  status?: boolean;
};

function hasGtmConsent(serviceName: string): boolean {
  if (!window.UC_UI) {
    return false;
  }

  const services = window.UC_UI.getServicesBaseInfo() as UsercentricsService[];

  return services.some(service => {
    const consentStatus = service.consent?.status ?? service.status ?? false;
    return service.name === serviceName && consentStatus === true;
  });
}

function loadGtm(): void {
  if (document.getElementById('gtm-script')) {
    return;
  }

  const windowWithDataLayer = window as Window & {
    dataLayer?: Array<Record<string, unknown>>;
  };

  windowWithDataLayer.dataLayer = windowWithDataLayer.dataLayer || [];
  windowWithDataLayer.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const firstScript = document.getElementsByTagName('script')[0];
  const gtmScript = document.createElement('script');

  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  gtmScript.id = 'gtm-script';

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  } else {
    document.head.appendChild(gtmScript);
  }
}

export default () => {
  const gtmServiceName = 'Google Tag Manager';
  let hasLoaded = false;

  const tryLoadGtm = (event?: Event) => {
    if (hasLoaded) {
      return;
    }

    if (event) {
      const customEvent = event as CustomEvent<{ type?: string }>;
      const eventType = customEvent.detail?.type || event.type;
      if (!USERCENTRICS_RELEVANT_EVENTS.has(eventType)) {
        return;
      }
    }

    if (hasGtmConsent(gtmServiceName)) {
      loadGtm();
      hasLoaded = true;
      window.removeEventListener('UC_UI_CMP_EVENT', tryLoadGtm);
      window.removeEventListener('UC_UI_INITIALIZED', tryLoadGtm);
    }
  };

  window.addEventListener('UC_UI_CMP_EVENT', tryLoadGtm);
  window.addEventListener('UC_UI_INITIALIZED', tryLoadGtm);
  tryLoadGtm();
};
